import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import { useMe } from 'pobble-components/dist/pobble-user'
import { Modal, ModalContent, ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import posthog from 'posthog-js'
import { PARENT_PRIMARY_CTA } from '../pages/parent/parent-theme'
import illustration from '../pages/parent/illustrations/parents-child.png'

export const ParentRestrictedModal = injectSheet({
  content: {
    width: '100%',
    maxWidth: '640px',
    '& h3': {
      margin: '20px 0 24px',
      color: '#111827',
      font: 'var(--heading--)',
      textAlign: 'center'
    }
  },
  body: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '24px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      gap: '32px'
    }
  },
  illustration: {
    flexShrink: 0,
    width: '100%',
    maxWidth: '240px',
    display: 'block'
  },
  text: {
    margin: 0,
    color: '#4b5563',
    font: 'var(--body)',
    lineHeight: 1.5,
    textAlign: 'left'
  },
  cta: PARENT_PRIMARY_CTA
})(function ParentRestrictedModal({ classes }) {
  const { me } = useMe()
  const isRestricted = me?.account?.subscription_policy?.parent_app?.restricted

  useEffect(
    () => {
      if (isRestricted) {
        posthog.capture('shown parent restricted modal', {
          url: window.location.href
        })
      }
    },
    [isRestricted]
  )

  if (!isRestricted) {
    return null
  }

  return (
    <Modal isOpen>
      <ModalContent className={classes.content}>
        <h3 className={classes.title}>You'll need a subscription</h3>
        <div className={classes.body}>
          <img
            className={classes.illustration}
            src={illustration}
            alt="Parent and child writing together"
          />
          <p className={classes.text}>
            Pobble Home gives your child picture prompts, gentle guidance, and a
            simple way to write at home. No lessons, no pressure, just writing
            together. <br />
            <br />Choose a plan to get started.
          </p>
        </div>
      </ModalContent>
      <ModalFooter alignRight>
        <Button
          tall
          minw
          className={classes.cta}
          action={() => {
            posthog.capture('clicks on cta from parent restricted modal', {
              url: window.location.href
            })
            window.location.href =
              '/account/membership/parent?from=restricted-modal'
          }}>
          See pricing
        </Button>
      </ModalFooter>
    </Modal>
  )
})
